import pricing from './pricing/routes';

export default [pricing];
